import { Timeline } from '../../../vendor_core/core/src/Timeline';
import CommandManager from '../../../vendor_core/core/src/commands/CommandManager';
import { DefaultLayers } from '../../../vendor_core/core/src/utils/Layers';
import Layout from '../../../vendor_core/core/src/utils/Layout';
import ViewManager from '../../../vendor_core/core/src/utils/ViewManager';
import Settings from '../../../vendor_core/src/base/ui/VendorSettings'
import LogoHelper from './logo/LogoHelper';
export default class MSSettings extends Settings {

    private timeline: Timeline;

    constructor() {
        super();

        this.timeline = new Timeline({});
    }
    updateTitle() {
        let  pageNames = ViewManager.getLayer(DefaultLayers.MenuUI).setScene("open");
        let pgNamesMap = new Map([
            ["paytable", "ui_paytable"],
            ["settings", "ui_settings"],
            ["gameinfo", "ui_game_rules"],
        ])
        pageNames.sceneTextFields.forEach((el, name) => {
            if(name == pgNamesMap.get(this.currentSettingsPage)) {
                el.visible = true;
            } else {
                if (name !== "ui_sub_title") {
                    el.visible = false;
                }
            }
        })
    }

    public show(arg: string) {
        LogoHelper.fixLogoSize(true);
        super.show(arg);
    }

    public hide() {
        LogoHelper.fixLogoSize(false);
        super.hide();
    }
}
